import "core-js/modules/es.array.push.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-00cbe41e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "out-box"
};
const _hoisted_2 = {
  class: "content-box"
};
const _hoisted_3 = {
  style: {
    "display": "flex",
    "flex": "1",
    "overflow": "hidden",
    "padding": "0px 30px"
  }
};
const _hoisted_4 = {
  style: {
    "width": "500px",
    "overflow-y": "auto",
    "flex-direction": "column"
  }
};
const _hoisted_5 = {
  style: {
    "display": "flex",
    "justify-content": "end"
  }
};
const _hoisted_6 = {
  style: {
    "flex": "1",
    "display": "flex",
    "flex-direction": "column",
    "overflow": "hidden",
    "margin-left": "30px",
    "margin-top": "20px"
  }
};
const _hoisted_7 = {
  style: {
    "flex": "1",
    "overflow": "hidden",
    "flex-direction": "column"
  }
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "编辑", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "删除", -1));
const _hoisted_10 = {
  style: {
    "height": "60px",
    "display": "flex",
    "justify-content": "end",
    "align-items": "end"
  }
};
const _hoisted_11 = {
  style: {
    "display": "flex",
    "flex": "1",
    "overflow": "hidden",
    "padding": "15px 20px"
  }
};
const _hoisted_12 = {
  style: {
    "flex": "1",
    "overflow-y": "auto",
    "flex-direction": "column",
    "background-color": "#e9e9e9",
    "border-radius": "12px",
    "border": "1px solid #818181",
    "padding": "30px",
    "font-size": "12px",
    "color": "#818181"
  }
};
const _hoisted_13 = ["innerHTML"];
const _hoisted_14 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Edit", -1));
const _hoisted_16 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
import { ref, reactive, onMounted, getCurrentInstance, h, nextTick, createVNode, computed } from "vue";
import util from "@/util/util";
import permission from "@/util/permission";
import { Modal, message } from "ant-design-vue";
import { DownCircleOutlined, PlusOutlined, ExclamationCircleOutlined } from "@ant-design/icons-vue";
import ResizePane from "@/components/ResizePane.vue";
import dayjs from "dayjs";
import { useRouter, useRoute } from "vue-router";

import { ElNotification } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/notification/style/css';
export default {
  __name: 'TestInteraction',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const router = useRouter();
    const route = useRoute();
    const itemId = route.params.itemId;
    const activeTabsKey = ref("1");
    const storeData = reactive([]);
    const storeOptions = reactive([]);
    const activityStatsItemForm = ref(null);
    const activityStatsItemFormData = ref({});
    const activityStatsItemTable = ref(null);
    const activityStatsItemData = reactive({
      data: []
    });
    const activityColumnData = reactive([]);
    const activityStatsItemPagination = reactive({
      pageSizes: [25, 50, 100],
      currentPage: 1,
      totalSize: 2000,
      pageSize: 25
    });
    const activityStatsItemOpen = ref(false);
    const activityStatsItemEditForm = ref(null);
    const activityStatsItemEditFormData = ref({});
    const columnRender = ref("");

    // 原始代码
    const codeHtml = ref(``);
    const highlightedCode = computed(() => {
      let highlightedText = code.value;
      return highlightedText;
    });
    const currentUrl = `${window.location.protocol}//${window.location.host}/`;
    const currentStatsItemUserType = ref(null);
    const getActivityStatsItemRequest = async itemId => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.getActivityStatsItem(itemId).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "失败",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    onMounted(async () => {
      let activityStatsItem = await getActivityStatsItemRequest(itemId);
      currentStatsItemUserType.value = activityStatsItem.userType;
      if (currentStatsItemUserType.value === 1) {
        activeTabsKey.value = "2";
      }
      debugger;
      let activityColumn = await getActivityColumn(itemId);
      activityColumnData.push(...activityColumn);
      let columnList = activityColumnData.filter(column => column.name !== "store_name");
      let storeList = await getStore();
      if (storeList == null) {
        return;
      }
      storeData.push(...storeList);
      storeOptions.push(...storeList.map(store => ({
        value: store.storeCode,
        label: store.storeName
      })));
      getActivityStatsData(itemId, 1, activityStatsItemPagination.pageSize);
      codeHtml.value = `
<span style=\'color:red\'>红色部分请替换成实际数据</span>
var axios = require('axios');
var qs = require('qs');
var data = qs.stringify({
   'username': '<span style=\'color:red\'>XXXX@XXXX.com</span>',
   'password': '<span style=\'color:red\'>XXXXXX</span>',
   'grant_type': 'password' 
});
var config = {
   method: 'post',
   url: '` + currentUrl + `api/oauth/token',
   headers: { 
      'Authorization': 'Basic ZXJwLWNsaWVudDpzZWNyZXQ=', 
      'User-Agent': 'Apifox/1.0.0 (https://apifox.com)'
   },
   data : data
};

axios(config)
.then(function (response) {
   console.log(JSON.stringify(response.data));
})
.catch(function (error) {
   console.log(error);
});

<span style=\'color:green\'>/*
Return Value
{
    "access_token": "<span style=\'color:red\'>4db20a4c-9b82-416a-8079-1feb319d9083</span>",
    "token_type": "bearer",
    "refresh_token": "50521655-2cdd-4c94-9d00-347b90951002",
    "expires_in": 41374,
    "scope": "read write trust",
}
*/</span>


var axios = require('axios');
var data = JSON.stringify({
   "itemId": "123",
   "data": [
      {\n`;
      for (let i = 0; i < columnList.length; i++) {
        let column = columnList[i];
        codeHtml.value += '           "' + column.name + '":"<span style=\'color:red\'>xxx</span>"';
        if (i < columnList.length - 1) {
          codeHtml.value += ",\n";
        }
      }
      codeHtml.value += `
      },
   ]
});

var config = {
   method: 'post',
   url: '` + currentUrl + `api/activity/add/stats',
   headers: { 
      'Authorization': 'Bearer <span style=\'color:red\'>4db20a4c-9b82-416a-8079-1feb319d9083</span>', 
      'User-Agent': 'Apifox/1.0.0 (https://apifox.com)', 
      'Content-Type': 'application/json'
   },
   data : data
};

axios(config)
.then(function (response) {
   console.log(JSON.stringify(response.data));
})
.catch(function (error) {
   console.log(error);
});
`;
    });
    const getColumnRules = column => {
      let rules = [];
      if (column.required === true) {
        rules.push({
          required: true,
          message: "请输入" + column.title
        });
      }
      if (["bigint", "int"].includes(column.type)) {
        rules.push({
          validator: validateInteger
        });
      }
      if (["double", "float", "decimal"].includes(column.type)) {
        rules.push({
          validator: validateNumber
        });
      }
      return rules;
    };
    const validateInteger = (rule, value) => {
      if (!value || /^[0-9]+$/.test(value)) {
        return Promise.resolve();
      }
      return Promise.reject("Please input integer");
    };
    const validateNumber = (rule, value) => {
      if (!value || /^[0-9]+$/.test(value) || /^[0-9]*\.[0-9]+$/.test(value)) {
        return Promise.resolve();
      }
      return Promise.reject("Please input number");
    };
    const getColumnFormatter = columnName => {
      return ({
        cellValue
      }) => {
        let column = activityColumnData.find(column => column.name === columnName) || null;
        if (column.type === "date") {
          return dayjs(cellValue).format("YYYY-MM-DD");
        } else if (column.type === "datetime") {
          return dayjs(cellValue).format("YYYY-MM-DD HH:mm:ss");
        }
        return cellValue;
      };
    };
    const getColumnFormatterValue = columnName => {
      return ({
        cellValue
      }) => {
        let column = activityColumnData.find(column => column.name === columnName) || null;
        if (column.type === "date") {
          return dayjs(cellValue, "YYYY-MM-DD");
        } else if (column.type === "datetime") {
          return dayjs(cellValue, "YYYY-MM-DD HH:mm:ss");
        }
        return cellValue;
      };
    };

    //单个活动表头
    const getActivityColumn = async itemId => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.getActivityColumn(itemId).then(res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "1400") {
              resolve(res.result.data);
            } else {
              ElNotification({
                title: "Failure",
                message: res.result.dataMsg,
                type: "error",
                duration: 3000
              });
            }
          } else {
            ElNotification({
              title: "Failure",
              message: res.msg,
              type: "error",
              duration: 3000
            });
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "Error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };

    //获取所有店铺
    const getStore = async () => {
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getStoreAll(true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "失败",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getActivityStatsData = async (activityStatsItemId, currentPage, pageSize) => {
      let obj = {
        pageIndex: currentPage,
        pageSize: pageSize,
        data: {
          itemId: activityStatsItemId
        }
      };
      proxy.$api.activityStatsRequest.getActivityStatsData(obj).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "2100") {
            let activityStatsItems = res.result.data;
            activityStatsItemPagination.totalSize = activityStatsItems.totalCount;
            if (Array.isArray(activityStatsItems.pageList)) {
              activityStatsItemData.data = activityStatsItems.pageList;
              for (let column of activityColumnData) {
                let maxWidth = getHTMLWidth(column.title);
                for (let item of activityStatsItemData.data) {
                  let formatter = getColumnFormatter(column.name);
                  item[column.name] = formatter({
                    cellValue: item[column.name]
                  });
                  if (item[column.name] != null && item[column.name] != "") {
                    let width = getHTMLWidth(item[column.name]);
                    if (width > maxWidth) {
                      maxWidth = width;
                    }
                  }
                }
                if (maxWidth > 0) {
                  column.width = Math.ceil(maxWidth) + 40;
                }
              }
            } else {
              activityStatsItemData.data.length = 0;
            }
          } else {
            ElNotification({
              title: "Failure",
              message: res.result.dataMsg,
              type: "error",
              duration: 3000
            });
          }
        } else {
          ElNotification({
            title: "Failure",
            message: res.msg,
            type: "error",
            duration: 3000
          });
        }
      }).catch(error => {
        if (error.code == "TOKEN_MISSING") {} else {
          ElNotification({
            title: "Error",
            message: error,
            type: "error",
            duration: 3000
          });
        }
      });
    };

    // 新增活动数据
    const addActivityStats = async infoDataMap => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.addActivityStats(infoDataMap).then(res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "2000") {
              getActivityStatsData(itemId, activityStatsItemPagination.currentPage, activityStatsItemPagination.pageSize);
              resolve(res.result);
              ElNotification({
                title: "Success",
                message: res.result.dataMsg,
                type: "success",
                duration: 3000
              });
            } else {
              ElNotification({
                title: "Failure",
                message: res.result.dataMsg,
                type: "error",
                duration: 3000
              });
            }
          } else {
            ElNotification({
              title: "Failure",
              message: res.msg,
              type: "error",
              duration: 3000
            });
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "Error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };

    // 新增活动数据
    const editActivityStats = async infoDataMap => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.editActivityStats(infoDataMap).then(res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "2200") {
              getActivityStatsData(itemId, activityStatsItemPagination.currentPage, activityStatsItemPagination.pageSize);
              activityStatsItemOpen.value = false;
              resolve(res.result);
              ElNotification({
                title: "Success",
                message: res.result.dataMsg,
                type: "success",
                duration: 3000
              });
            } else {
              ElNotification({
                title: "Failure",
                message: res.result.dataMsg,
                type: "error",
                duration: 3000
              });
            }
          } else {
            ElNotification({
              title: "Failure",
              message: res.msg,
              type: "error",
              duration: 3000
            });
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "Error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const removeActivityStatsItem = row => {
      Modal.confirm({
        title: "提示",
        icon: createVNode(ExclamationCircleOutlined),
        okButtonProps: {
          class: "sts-button default",
          style: "height:22px"
        },
        cancelButtonProps: {
          class: "sts-button default",
          style: "height:22px"
        },
        zIndex: 1002,
        content: "要删除记录吗",
        onOk() {
          let activityStatsDelete = {
            itemId: itemId,
            id: row.id
          };
          deleteActivityStats(activityStatsDelete);
        }
      });
    };

    // 删除活动数据
    const deleteActivityStats = async activityStatsDelete => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.deleteActivityStats(activityStatsDelete).then(res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "2300") {
              getActivityStatsData(itemId, activityStatsItemPagination.currentPage, activityStatsItemPagination.pageSize);
              resolve(res.result);
              ElNotification({
                title: "Success",
                message: res.result.dataMsg,
                type: "success",
                duration: 3000
              });
            } else {
              ElNotification({
                title: "Failure",
                message: res.result.dataMsg,
                type: "error",
                duration: 3000
              });
            }
          } else {
            ElNotification({
              title: "Failure",
              message: res.msg,
              type: "error",
              duration: 3000
            });
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "Error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const paginationCurrentActivityStatsItemChange = val => {
      getActivityStatsData(itemId, val.currentPage, val.pageSize);
    };
    const backEvent = () => {
      router.go(-1);
    };
    const testEvent = async () => {
      activityStatsItemForm.value.validate().then(async () => {
        let formData = JSON.parse(JSON.stringify(activityStatsItemFormData.value));
        for (let column of activityColumnData) {
          if (column.type == "datetime") {
            formData[column.name] = dayjs(formData[column.name]).format("YYYY-MM-DD HH:mm:ss");
          } else if (column.type == "date") {
            formData[column.name] = dayjs(formData[column.name]).format("YYYY-MM-DD");
          }
        }
        let infoDataMap = {
          itemId: itemId,
          data: [formData]
        };
        let addRes = await addActivityStats(infoDataMap);
      }).catch(error => {
        console.log("error", error);
      });
    };
    const filterStoreOption = (input, option) => {
      return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    };
    const getHTMLWidth = (htmlString, fontSize = "12px", fontFamily = "SourceHanSansCN-Regular") => {
      // 创建一个隐藏的span元素用于测量宽度
      let span = document.createElement("span");

      // 设置样式以确保测量结果的准确性
      span.style.position = "absolute";
      span.style.visibility = "hidden";
      span.style.whiteSpace = "nowrap";
      span.style.fontSize = fontSize;
      span.style.fontFamily = fontFamily;

      // 使用innerHTML插入HTML字符串
      span.innerHTML = htmlString;

      // 将测量元素添加到文档中
      document.body.appendChild(span);

      // 获取测量元素的宽度
      let width = span.getBoundingClientRect().width;

      // 从文档中移除测量元素
      span.remove();
      return width;
    };
    const editActivityStatsItem = row => {
      for (let column of activityColumnData) {
        let formatter = getColumnFormatterValue(column.name);
        activityStatsItemEditFormData.value[column.name] = formatter({
          cellValue: row[column.name]
        });
      }
      activityStatsItemEditFormData.value.id = row.id;
      activityStatsItemOpen.value = true;
    };
    const onActivityStatsItemSave = () => {
      activityStatsItemEditForm.value.validate().then(async () => {
        let formData = JSON.parse(JSON.stringify(activityStatsItemEditFormData.value));
        for (let column of activityColumnData) {
          if (column.type == "datetime") {
            formData[column.name] = dayjs(formData[column.name]).format("YYYY-MM-DD HH:mm:ss");
          } else if (column.type == "date") {
            formData[column.name] = dayjs(formData[column.name]).format("YYYY-MM-DD");
          }
        }
        delete formData.store_name;
        let infoDataMap = {
          itemId: itemId,
          id: formData.id,
          data: [formData]
        };
        let addRes = await editActivityStats(infoDataMap);
      }).catch(error => {
        console.log("error", error);
      });
    };
    const onActivityStatsItemCancel = () => {
      activityStatsItemEditForm.value.resetFields();
      activityStatsItemOpen.value = false;
    };
    return (_ctx, _cache) => {
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_col = _resolveComponent("a-col");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_date_picker = _resolveComponent("a-date-picker");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_row = _resolveComponent("a-row");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_button = _resolveComponent("a-button");
      const _component_vxe_column = _resolveComponent("vxe-column");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_menu_item = _resolveComponent("a-menu-item");
      const _component_a_menu = _resolveComponent("a-menu");
      const _component_a_dropdown = _resolveComponent("a-dropdown");
      const _component_vxe_table = _resolveComponent("vxe-table");
      const _component_a_config_provider = _resolveComponent("a-config-provider");
      const _component_vxe_pager = _resolveComponent("vxe-pager");
      const _component_a_tab_pane = _resolveComponent("a-tab-pane");
      const _component_a_tabs = _resolveComponent("a-tabs");
      const _component_a_divider = _resolveComponent("a-divider");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_config_provider, {
        theme: {
          components: {
            Tabs: {
              fontSize: 18,
              colorPrimary: '#777777',
              colorText: '#C4C4C4'
            }
          }
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_a_tabs, {
          activeTabsKey: activeTabsKey.value,
          "onUpdate:activeTabsKey": _cache[3] || (_cache[3] = $event => activeTabsKey.value = $event)
        }, {
          default: _withCtx(() => [currentStatsItemUserType.value !== 1 ? (_openBlock(), _createBlock(_component_a_tab_pane, {
            key: "1",
            tab: "测试数据"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_a_form, {
              model: activityStatsItemFormData.value,
              ref_key: "activityStatsItemForm",
              ref: activityStatsItemForm,
              class: "sts-form",
              "label-col": {
                span: 8
              },
              "label-align": "left",
              autocomplete: "off",
              style: {
                "margin-top": "20px",
                "flex": "1",
                "width": "500px"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_a_row, null, {
                default: _withCtx(() => [_createVNode(_component_a_col, {
                  span: 16
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_form_item, {
                    label: '活动ID:'
                  }, {
                    default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(_unref(itemId)), 1)]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_a_col, {
                  span: 16
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_form_item, {
                    label: '店铺名称:',
                    name: 'store_code',
                    rules: [{
                      required: true,
                      message: '请选择店铺名称'
                    }]
                  }, {
                    default: _withCtx(() => [_createVNode(_component_a_select, {
                      "show-search": "",
                      dropdownMatchSelectWidth: false,
                      options: storeOptions,
                      popupClassName: "sts-select-dropdown",
                      style: {
                        "width": "355px"
                      },
                      value: activityStatsItemFormData.value['store_code'],
                      "onUpdate:value": _cache[0] || (_cache[0] = $event => activityStatsItemFormData.value['store_code'] = $event),
                      "filter-option": filterStoreOption
                    }, {
                      suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
                        class: "ant-select-suffix"
                      })]),
                      _: 1
                    }, 8, ["options", "value"])]),
                    _: 1
                  })]),
                  _: 1
                }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityColumnData.filter(column => column.name !== 'store_name' && column.name !== 'store_code'), (column, index) => {
                  return _openBlock(), _createBlock(_component_a_col, {
                    key: index,
                    span: 16
                  }, {
                    default: _withCtx(() => [_createVNode(_component_a_form_item, {
                      label: column.title + ':',
                      name: column.name,
                      rules: getColumnRules(column)
                    }, {
                      default: _withCtx(() => [column.type === 'datetime' ? (_openBlock(), _createBlock(_component_a_date_picker, {
                        key: 0,
                        class: "sts-picker",
                        popupClassName: "sts-picker",
                        value: activityStatsItemFormData.value[column.name],
                        "onUpdate:value": $event => activityStatsItemFormData.value[column.name] = $event,
                        format: "YYYY-MM-DD HH:mm:ss",
                        "show-time": {
                          defaultValue: _unref(dayjs)('00:00:00', 'HH:mm:ss')
                        },
                        style: {
                          "width": "355px"
                        }
                      }, null, 8, ["value", "onUpdate:value", "show-time"])) : column.type === 'date' ? (_openBlock(), _createBlock(_component_a_date_picker, {
                        key: 1,
                        class: "sts-picker",
                        popupClassName: "sts-picker",
                        value: activityStatsItemFormData.value[column.name],
                        "onUpdate:value": $event => activityStatsItemFormData.value[column.name] = $event,
                        style: {
                          "width": "355px"
                        }
                      }, null, 8, ["value", "onUpdate:value"])) : (_openBlock(), _createBlock(_component_a_input, {
                        key: 2,
                        value: activityStatsItemFormData.value[column.name],
                        "onUpdate:value": $event => activityStatsItemFormData.value[column.name] = $event,
                        style: {
                          "width": "355px"
                        }
                      }, null, 8, ["value", "onUpdate:value"]))]),
                      _: 2
                    }, 1032, ["label", "name", "rules"])]),
                    _: 2
                  }, 1024);
                }), 128))]),
                _: 1
              })]),
              _: 1
            }, 8, ["model"]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_a_button, {
              onClick: backEvent,
              class: "sts-button default"
            }, {
              default: _withCtx(() => [_createTextVNode("返回")]),
              _: 1
            }), _createVNode(_component_a_button, {
              onClick: testEvent,
              class: "sts-button default",
              style: {
                "margin-left": "30px",
                "margin-right": "20px"
              }
            }, {
              default: _withCtx(() => [_createTextVNode("测试")]),
              _: 1
            })])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_a_config_provider, {
              theme: {
                components: {
                  Button: {
                    controlHeight: 24
                  }
                }
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_vxe_table, {
                stripe: "",
                height: "auto",
                data: activityStatsItemData.data,
                ref_key: "activityStatsItemTable",
                ref: activityStatsItemTable,
                class: "sts-table",
                "show-overflow": ""
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityColumnData, (column, index) => {
                  return _openBlock(), _createBlock(_component_vxe_column, {
                    key: index,
                    field: column.name,
                    title: column.title,
                    "min-width": column.width
                  }, null, 8, ["field", "title", "min-width"]);
                }), 128)), _createVNode(_component_vxe_column, {
                  width: "100",
                  fixed: "right",
                  title: "action"
                }, {
                  default: _withCtx(({
                    row
                  }) => [_createVNode(_component_a_dropdown, {
                    trigger: ['click']
                  }, {
                    overlay: _withCtx(() => [_createVNode(_component_a_menu, null, {
                      default: _withCtx(() => [_createVNode(_component_a_menu_item, {
                        key: "0",
                        onClick: $event => editActivityStatsItem(row)
                      }, {
                        default: _withCtx(() => [_hoisted_8]),
                        _: 2
                      }, 1032, ["onClick"]), _createVNode(_component_a_menu_item, {
                        key: "1",
                        onClick: $event => removeActivityStatsItem(row)
                      }, {
                        default: _withCtx(() => [_hoisted_9]),
                        _: 2
                      }, 1032, ["onClick"])]),
                      _: 2
                    }, 1024)]),
                    default: _withCtx(() => [_createVNode(_component_a_button, {
                      class: "sts-button-circle-icon default",
                      shape: "circle"
                    }, {
                      default: _withCtx(() => [_createVNode(_component_svg_icon, {
                        iconName: "more",
                        iconColor: '#777777',
                        iconSize: "16px"
                      })]),
                      _: 1
                    })]),
                    _: 2
                  }, 1024)]),
                  _: 1
                })]),
                _: 1
              }, 8, ["data"])]),
              _: 1
            })]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_vxe_pager, {
              class: "sts-pager",
              background: "",
              "page-size": activityStatsItemPagination.pageSize,
              "onUpdate:pageSize": _cache[1] || (_cache[1] = $event => activityStatsItemPagination.pageSize = $event),
              "current-page": activityStatsItemPagination.currentPage,
              "onUpdate:currentPage": _cache[2] || (_cache[2] = $event => activityStatsItemPagination.currentPage = $event),
              "pager-count": 5,
              total: activityStatsItemPagination.totalSize,
              layouts: ['PrevJump', 'JumpNumber', 'NextJump', 'Sizes', 'FullJump', 'Total'],
              onPageChange: paginationCurrentActivityStatsItemChange
            }, null, 8, ["page-size", "current-page", "total"])])])])]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_a_tab_pane, {
            key: "2",
            tab: "活动代码",
            "force-render": ""
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("pre", {
              innerHTML: codeHtml.value
            }, null, 8, _hoisted_13)])])]),
            _: 1
          })]),
          _: 1
        }, 8, ["activeTabsKey"])]),
        _: 1
      })])]), _createVNode(_component_a_modal, {
        open: activityStatsItemOpen.value,
        "onUpdate:open": _cache[5] || (_cache[5] = $event => activityStatsItemOpen.value = $event),
        closable: false,
        onOk: _ctx.handleOk,
        zIndex: "1001",
        centered: true
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_hoisted_15, _createVNode(_component_a_divider, {
          style: {
            "margin": "10px 30px 10px 20px",
            "min-width": "0px"
          }
        })])]),
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_createVNode(_component_a_divider, {
          style: {
            "margin": "10px 30px 10px 0px",
            "min-width": "0px"
          }
        }), _createVNode(_component_a_button, {
          class: "sts-button default",
          key: "back",
          onClick: onActivityStatsItemCancel
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_a_button, {
          class: "sts-button green",
          key: "submit",
          type: "primary",
          loading: _ctx.loading,
          onClick: onActivityStatsItemSave
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_a_form, {
          model: activityStatsItemEditFormData.value,
          ref_key: "activityStatsItemEditForm",
          ref: activityStatsItemEditForm,
          class: "sts-form",
          "label-col": {
            span: 8
          },
          "label-align": "left",
          autocomplete: "off",
          rules: _ctx.activityColumnValidRules
        }, {
          default: _withCtx(() => [_createVNode(_component_a_row, null, {
            default: _withCtx(() => [_createVNode(_component_a_col, null, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                label: '店铺名称:',
                name: 'store_code',
                rules: [{
                  required: true,
                  message: '请选择店铺名称'
                }],
                style: {
                  "width": "450px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_a_select, {
                  "show-search": "",
                  dropdownMatchSelectWidth: false,
                  options: storeOptions,
                  popupClassName: "sts-select-dropdown",
                  value: activityStatsItemEditFormData.value['store_code'],
                  "onUpdate:value": _cache[4] || (_cache[4] = $event => activityStatsItemEditFormData.value['store_code'] = $event),
                  "filter-option": filterStoreOption
                }, {
                  suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
                    class: "ant-select-suffix"
                  })]),
                  _: 1
                }, 8, ["options", "value"])]),
                _: 1
              })]),
              _: 1
            }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityColumnData.filter(column => column.name !== 'store_name' && column.name !== 'store_code'), (column, index) => {
              return _openBlock(), _createBlock(_component_a_col, {
                key: index,
                span: 16
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  label: column.title + ':',
                  name: column.name,
                  rules: column.required === true ? [{
                    required: true,
                    message: '请输入' + column.title
                  }] : [],
                  style: {
                    "width": "450px"
                  }
                }, {
                  default: _withCtx(() => [column.type === 'datetime' ? (_openBlock(), _createBlock(_component_a_date_picker, {
                    key: 0,
                    class: "sts-picker",
                    popupClassName: "sts-picker",
                    value: activityStatsItemEditFormData.value[column.name],
                    "onUpdate:value": $event => activityStatsItemEditFormData.value[column.name] = $event,
                    format: "YYYY-MM-DD HH:mm:ss",
                    "show-time": {
                      defaultValue: _unref(dayjs)('00:00:00', 'HH:mm:ss')
                    },
                    style: {
                      "width": "100%"
                    }
                  }, null, 8, ["value", "onUpdate:value", "show-time"])) : column.type === 'date' ? (_openBlock(), _createBlock(_component_a_date_picker, {
                    key: 1,
                    class: "sts-picker",
                    popupClassName: "sts-picker",
                    value: activityStatsItemEditFormData.value[column.name],
                    "onUpdate:value": $event => activityStatsItemEditFormData.value[column.name] = $event,
                    style: {
                      "width": "100%"
                    }
                  }, null, 8, ["value", "onUpdate:value"])) : (_openBlock(), _createBlock(_component_a_input, {
                    key: 2,
                    value: activityStatsItemEditFormData.value[column.name],
                    "onUpdate:value": $event => activityStatsItemEditFormData.value[column.name] = $event,
                    style: {
                      "width": "100%"
                    }
                  }, null, 8, ["value", "onUpdate:value"]))]),
                  _: 2
                }, 1032, ["label", "name", "rules"])]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["open", "onOk"])], 64);
    };
  }
};